module.exports = __webpack_public_path__ + "img/exit.d8b17e7a.svg";